import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState } from 'react';
import InfoTooltipTemplate from '../InfoTooltipTemplate';

/**
 * A customizable dropdown (select) input template
 */
const CustomSelectTemplate = ({ appendTo="self", name, label, className, labelClassName, floatLabel, noMargins, bottomMargin, inline, value, options, placeholder, onChangeFunction, isValid, errorMessage, disabled, category, infoMessage }) => {
    const [inputClasses, setInputClasses] = useState(
        classNames({
            'p-invalid': isValid,
            'w-full': true,
        })
    );
    const [labelClasses, setLabelClasses] = useState(
        classNames({
            'p-error': isValid,
            'w-full': true,
            'block mb-2': !inline,
            'mr-2': inline,
            'pr-4': infoMessage,
        })
    );
    const [inputType, setInputType] = useState();

    const isDropdownValue = options.find((option) => option.value.toLowerCase().includes(value?.toLowerCase()));

    const inputField =
        inputType == 'text' ? (
            <span className="custom-select-input-wrap">
                <InputText id={name} value={value || ''} placeholder={placeholder} onChange={(e) => onChangeFunction(name, e.target.value, category)} className={inputClasses} />
                <i
                    className="pi pi-times p-button p-button-sm p-button-danger p-button-text p-1"
                    onClick={() => {
                        setInputType('dropdown');
                        onChangeFunction(name, '', category);
                    }}
                />
            </span>
        ) : inputType == 'dropdown' ? (
            <Dropdown
                appendTo={appendTo}
                id={name}
                value={value || ''}
                options={options}
                placeholder={placeholder}
                onChange={(e) => {
                    // console.log(e.target);
                    if (e.target.value == 'manual-input') {
                        setInputType('text');
                        onChangeFunction(name, '', category);
                    } else {
                        onChangeFunction(name, e.target.value, category);
                    }
                }}
                className={inputClasses}
                disabled={disabled}
            />
        ) : (
            <></>
        );

    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        isDropdownValue || value == '' || value === null ? setInputType('dropdown') : setInputType('text');
    }, []);

    return (
        <div className={(!noMargins ? 'mb-' + (bottomMargin || '5') : '') + +(infoMessage ? ' relative' : '')}>
            {floatLabel ? (
                <>
                    <span className="p-float-label">
                        {inputField}
                        <label htmlFor={name} className={labelClasses}>
                            {label}
                        </label>
                        {infoMessage && (
                            <div className="top-right-icon">
                                <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                            </div>
                        )}
                    </span>

                    {errorMessage}
                </>
            ) : (
                <>
                    {label && (
                        <label htmlFor={name} className={labelClasses} title={ labelClassName == 'one-line' ? label : null }>
                            {label}
                        </label>
                    )}
                    {infoMessage && (
                        <div className="top-right-icon">
                            <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                        </div>
                    )}
                    {inputField}
                    {errorMessage}
                </>
            )}
        </div>
    );
};

export default CustomSelectTemplate;
